<template>
  <div class="page-container pt-3 pb-4 speaker-profile-page">
    <div class="bio-container mb-4">
      <bio type="torah" :magidShiur="magidShiur"></bio>
    </div>
    <shiurim-table :magid-shiur="magidShiur" />
  </div>
</template>
<script>
import BioComponent from "./magideiShiur/bio.vue";
import ShiurimTableComponent from "./torahShiurim/MagidShiurTable.vue";
export default {
  components: {
    Bio: BioComponent,
    ShiurimTable: ShiurimTableComponent,
  },
  i18nOptions: {
    namespaces: "pages",
    keyPrefix: "magidShiurTorah",
  },
  metaInfo: function () {
    return {
      title: this.metaTitle,
      titleTemplate: null,
      meta: [{ name: 'description', content: this.metaTitle }],
    };
  },
  computed: {
    metaTitle: function() {
      return this.magidShiur ? this.$_t('KW:site.metaTorahWithName', { name: this.magidShiur.name }) : this.$_t('KW:site.metaTorahWithoutName');
    },
  },
  data: function () {
    return {
      magidShiur: {
        name: null,
        topics: [],
        parent_topics: [],
      },
    };
  },
  created: function () {
    this.getData();
  },
  watch: {
    $route: "getData",
  },
  methods: {
    getData: function () {
      let self = this;
      this.loading = true;
      this.$http
        .get("/api/magidei-shiur/torah/" + this.$route.params.slug)
        .then(function (response) {
          self.magidShiur = response.data;
          self.loading = false;
          // self.options.listColumns.masechta_id =
          // 	response.data.masechtot;
        })
        .catch(function (error) {
          self.loading = false;
          self.error = true;
        });
    },
  },
};
</script>
<style>
